const POLAND_FACEID_LOCATIONS = new Set(['Rondo Daszyńskiego 2B', 'Icchoka Lejba Pereca 1']);

export const timezoneForFaceidLocation = (location?: string | null): string => {
  if (location && POLAND_FACEID_LOCATIONS.has(location)) {
    return 'Europe/Warsaw';
  }
  return 'Europe/Minsk';
};

/**
 * Format a UTC ISO datetime (or any parseable absolute instant) as HH:mm:ss
 * in the given IANA timezone. Falls back to Europe/Minsk.
 */
export const formatTimeInTimeZone = (dateTime: string | null | undefined, timeZone?: string | null): string | null => {
  if (!dateTime) {
    return null;
  }

  const date = new Date(dateTime);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return new Intl.DateTimeFormat('en-GB', {
    timeZone: timeZone || 'Europe/Minsk',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
};
